import { compareVersions, } from '@standardnotes/models';
import { encryptedInputParametersFromPayload, } from '../Types/EncryptedParameters';
import { isAsyncOperator } from './OperatorInterface/TypeCheck';
export async function encryptPayload(payload, key, operatorManager, signingKeyPair) {
    const operator = operatorManager.operatorForVersion(key.keyVersion);
    let result = undefined;
    if (isAsyncOperator(operator)) {
        result = await operator.generateEncryptedParametersAsync(payload, key);
    }
    else {
        result = operator.generateEncryptedParameters(payload, key, signingKeyPair);
    }
    if (!result) {
        throw 'Unable to generate encryption parameters';
    }
    return result;
}
export async function decryptPayload(payload, key, operatorManager) {
    if (compareVersions(payload.version, key.keyVersion) < 0) {
        return {
            uuid: payload.uuid,
            errorDecrypting: true,
        };
    }
    const operator = operatorManager.operatorForVersion(payload.version);
    try {
        if (isAsyncOperator(operator)) {
            return await operator.generateDecryptedParametersAsync(encryptedInputParametersFromPayload(payload), key);
        }
        else {
            return operator.generateDecryptedParameters(encryptedInputParametersFromPayload(payload), key);
        }
    }
    catch (e) {
        console.error('Error decrypting payload', payload, e);
        return {
            uuid: payload.uuid,
            errorDecrypting: true,
        };
    }
}
